import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import Icon from '@mdi/react';
import { mdiContentCopy, mdiImport } from '@mdi/js';
// import ThemeContext from './ThemeProvider';
// import { makeStyles, createStyles } from '@material-ui/core';
// import Snackbar, { SnackbarOrigin } from '@material-ui/core/Snackbar';
// import { Trans } from '@bit/deliverdotmedia.portal-components.i18n-strings';
// import { SearchContext } from './SearchContext';

// export interface TextToCopyProps {
//   text: string
//   name: string
//   source: string
// }

import './TextToCopy.scss';

const TextToCopy = (textprop) => {
    const { text, name, source } = textprop;

    // const theme = useContext(ThemeContext);
    // const classes = useStyles(theme);
    // const { search, addOrUpdateCompanionData } = useContext(SearchContext);
    // const { trackEvent } = useMatomo();

    // interface State extends SnackbarOrigin {
    //     open: boolean;
    // }

    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, open } = state;

    const handleClick = (newState) => () => {
        setState({ open: true, ...newState });
    };

    function handleClose() {
        setState({ ...state, open: false });
    }

    return (
        <div className="textToCopy">
            {text}
            <CopyToClipboard text={text}>
                <button
                    className="hiddenButton"
                    // className={classes.hiddenButton}
                    onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
                >
                    <Icon
                        path={mdiContentCopy}
                        title="Copy"
                        size={0.6}
                        color="rgba(0,0,0,0.8)"
                        className="copyIcon"
                    />
                </button>
            </CopyToClipboard>
            {/* <Snackbar
                autoHideDuration={2000}
                anchorOrigin={{ vertical, horizontal }}
                key={`${vertical},${horizontal}`}
                open={open}
                onClose={handleClose}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={
                    <span id="message-id">
                        <Trans i18nKey="copiedTextToClipboard">
                            Copied {{ text }} to clipboard!
                        </Trans>
                    </span>
                }
            /> */}
        </div>
    );
};

export { TextToCopy };
